import { render, staticRenderFns } from "./IanControls.vue?vue&type=template&id=15710c03&scoped=true&"
import script from "./IanControls.vue?vue&type=script&lang=js&"
export * from "./IanControls.vue?vue&type=script&lang=js&"
import style0 from "./IanControls.vue?vue&type=style&index=0&id=15710c03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15710c03",
  null
  
)

export default component.exports